export const DEFAULT_TOGGLE_TEXT_LENGTH = 100;
